export class NumberInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input");
    this.decreaseBtn = this.querySelector(".js-decrease");
    this.increaseBtn = this.querySelector(".js-increase");
  }

  connectedCallback() {
    this._attachEventListeners();
  }

  _attachEventListeners() {
    this.decreaseBtn?.addEventListener("click", this.decrease.bind(this));
    this.increaseBtn?.addEventListener("click", this.increase.bind(this));
    this.input.addEventListener("change", this._onValueChange.bind(this));
  }

  increase() {
    if (!this.max || this.value < this.max) {
      this.value += this.step;
      this._checkBoundaries();
      this.input.dispatchEvent(new Event("change"));
    }
  }

  decrease() {
    if (!this.min || this.value > this.min) {
      this.value -= this.step;
      this._checkBoundaries();
      this.input.dispatchEvent(new Event("change"));
    }
  }

  _onValueChange(e) {
    this._checkBoundaries();
  }

  _checkBoundaries() {
    this.increaseBtn.disabled = this.value === this.max;
    this.decreaseBtn.disabled = this.value === this.min;
  }

  get value() {
    return this.input.valueAsNumber;
  }

  set value(value) {
    this.input.valueAsNumber = value;
  }

  get step() {
    return this.input.step ? +this.input.step : 1;
  }

  get max() {
    return this.input.max ? +this.input.max : null;
  }

  get min() {
    return this.input.min ? +this.input.min : null;
  }
}

if (!customElements.get("number-input")) {
  customElements.define("number-input", NumberInput);
}
